import React, { useEffect, useContext } from "react";
import qs from "query-string";
import { RootContext } from "../../RootContextProvider";
import { Row, notification } from "antd";
import Blocks from "./Blocks";
import { useHistory, useLocation } from "react-router-dom";
import BannerUpgrade from "../Banners/BannerUpgrade";
import bannerBottom from "../../assets/visuals/banner-bottom-humans.png";

const Links = () => {
  const location = useLocation();
  const history = useHistory();
  const { account } = useContext(RootContext);
  const openNotificationWithIcon = (type, event) => {
    if (event === "pageCreated") {
      notification[type]({
        message: "Page créée avec succès",
        description: "Votre page a bien été créée 🤙",
      });
    }
    if (event === "pageDeleted") {
      notification[type]({
        message: "Page supprimée avec succès.",
        description: "Votre page a bien été supprimée",
      });
    }
  };

  useEffect(() => {
    const checkParams = async () => {
      let params = qs.parse(location.search);
      if (params.status === "pageCreated") {
        await openNotificationWithIcon("success", "pageCreated");
        history.push("/links");
      }
      if (params.status === "pageDeleted") {
        await openNotificationWithIcon("success", "pageDeleted");
        history.push("/links");
      }
    };
    checkParams();
    // eslint-disable-next-line
  }, []);

  return (
    <Row>
      <Blocks />
      {!account.IsPaying ? (
        <BannerUpgrade
          imgWidth="340px"
          image={bannerBottom}
          // color="#4d61fc"
          color="#8997FF"
          isAbsolute={false}
        />
      ) : (
        ""
      )}
    </Row>
  );
};
export default Links;
